import { useEffect, useState } from "react";
import { Button, Alert, Spinner } from "react-bootstrap";
import { restApiBase } from "../settings";
import { useParams } from "react-router-dom";
import ReportModal from "./ReportModal";

export function ReportDetail({ token, userId }) {
    const { reportId } = useParams();

    const [report, setReport] = useState(null);
    const [reportResult, setReportResult] = useState(null);
    const [showWarning, setShowWarning] = useState(false);
    const [loadingReport, setLoadingReport] = useState(false);

    const [modalUrl, setModalUrl] = useState(null);
    const [modalTitle, setModalTitle] = useState("");

    const [reportMetadata, setReportMetadata] = useState(null);

    useEffect(() => {
        if (!reportId) return;



        try {
            const reportsMap = JSON.parse(localStorage.getItem("reportHistory") || "{}");
            const report = reportsMap[reportId];

            if (!report) {

                setReportMetadata(null);

            } else {
                setReportMetadata(report.report_metadata);

            }
        } catch (err) {

            setReportMetadata(null);
            setReportResult(null);
        }
    }, [reportId]);


    useEffect(() => {
        if (!reportId) return;

        setReportResult(null);
        setShowWarning(false);

        async function fetchReport(retries = 3) {
            setLoadingReport(true);
            try {
                const url = `${restApiBase}get_report?user_id=${userId}&report_id=${reportId}`;
                const response = await fetch(url, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                if (!response.ok) throw new Error("HTTP " + response.status);
                const data = await response.json();
                if (data.error) {
                    setShowWarning(`${data.error}: ${data.error_description || ""}`);
                } else {
                    setReport(data);
                    setReportResult(data.report_urls);
                }
            } catch (error) {
                if (retries > 0) {
                    console.warn("Retrying fetch...", retries, error.message);
                    setTimeout(() => fetchReport(retries - 1), 2000);
                } else {
                    setShowWarning("Fetch error: " + error.message);
                }
            } finally {
                setLoadingReport(false);
            }
        }

        fetchReport();
    }, [reportId, token, userId]);

    if (!reportId) return <div>Report not selected</div>;
    if (showWarning) return <Alert variant="danger">{showWarning}</Alert>;
    if (loadingReport || !reportResult)
        return (
            <div className="d-flex align-items-center p-4">
                <Spinner animation="grow" role="status" className="me-2">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
                <span>Loading report...</span>
            </div>
        );

    const reportDate = new Date(report?.report_status?.created_at);
    const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
    };
    const formattedDate = reportDate.toLocaleDateString("en-US", options);

    const reportType = reportMetadata?.report_type;

    const reportTypeName = 
        reportType === "SAR_COUNTRY" ? "Sovereign Risk Analysis" :
        reportType === "SAR_CORPORATE" ? "Corporate Investment Risk Analysis" :
        "report";

    // Создаём массив названий кнопок в зависимости от reportType
    const btnTitles =
        reportType === "SAR_COUNTRY"
            ? [
                "Economy (Economic Performance)",
                "Market",
                "External",
                "Government and Politics",
            ]
            : ["Fiscal", "Industry", "Ownership", "Financial markets"];





    return (
        <div className="report-detail d-flex flex-column gap-3">
            <h4>Your {reportTypeName} report from {formattedDate}</h4>
            {reportMetadata && (
                <div className="report-parameters p-2 border rounded bg-light">
                    {reportMetadata.parameters?.target && (
                        <div>
                            <strong>Target:</strong> {reportMetadata.parameters.target}
                        </div>
                    )}
                            {reportMetadata.parameters?.scope?.length > 0 && (
                                <div>
                                    <strong>Scope:</strong>{" "}
                                    {reportMetadata.parameters.scope.join(", ")}
                                </div>
                    )}
                    {reportMetadata.options?.risk_factors?.length > 0 && (
                        <div>
                            <strong>Risk Factors:</strong>{" "}
                            {reportMetadata.options.risk_factors.join(", ")}
                        </div>
                    )}
                </div>
            )}

            <div className="d-flex flex-column gap-1 col-12 col-md-4">
                {reportResult.executive_summary_url && (
                    <Button
                        variant="outline-dark"
                        onClick={() => {
                            setModalTitle("Executive Summary");
                            setModalUrl(reportResult.executive_summary_url);
                        }}
                    >
                        Executive Summary
                    </Button>
                )}

                {reportResult.full_report_url && (
                    <Button
                        variant="outline-dark"
                        onClick={() => {
                            setModalTitle("Full Report");
                            setModalUrl(reportResult.full_report_url);
                        }}
                    >
                        Full Report
                    </Button>
                )}

                {reportResult.report_research_urls?.map((url, index) => (
                    <Button
                        key={index}
                        variant="outline-dark"
                        onClick={() => {
                            setModalTitle(`Report Research ${index + 1}`);
                            setModalUrl(url);
                        }}
                    >

                        {btnTitles[index] ?? `Report Research ${index + 1}`}

                    </Button>
                ))}
            </div>

            {/* Используем твой готовый модал */}
            <ReportModal
                url={modalUrl}
                title={modalTitle}
                onClose={() => setModalUrl(null)}
            />
        </div>
    );
}
